import React from "react";
import { MimaText, Modal } from "../../components";
import { fashCreativeStore } from "../../stores";
import { extractVideoInfo } from "../../utils/utils";

const SingleCatalogueModal = ({ closeModal }) => {
  const catalogue = fashCreativeStore.singleCatalogue;

  return (
    <Modal closeModal={closeModal}>
      <MimaText variant="subtitleBold" mb={4} width={38} align="center">
        Catalogue Details
      </MimaText>

      <MimaText mb={2} width={38} labelTitle="Style Name">
        {catalogue?.name}
      </MimaText>
      <MimaText mb={2} width={38} labelTitle="Style Description">
        {catalogue?.description}
      </MimaText>
      {catalogue?.business?.tradingName ? (
        <MimaText mb={2} width={38} labelTitle="Business">
          {catalogue?.business?.tradingName}
        </MimaText>
      ) : (
        ""
      )}
      <MimaText mb={2} width={38} labelTitle="Designer Name">
        {catalogue?.designerName}
      </MimaText>
      <MimaText mb={2} width={38} labelTitle="Hash Tags">
        {catalogue.hashTags.map((item, i) => (
          <div key={i}>
            <span>{item}</span>
          </div>
        ))}
      </MimaText>
      <MimaText mb={2} width={38} labelTitle="Gender">
        {catalogue?.gender}
      </MimaText>

      <MimaText
        mb={0.5}
        width={38}
        variant="small"
        color="var(--color-primary)"
      >
        Image(s)
      </MimaText>
      <div className="modal__beside__grid" style={{ marginBottom: "3rem" }}>
        {catalogue.imageUrls.map((img, i) => (
          <div key={i}>
            <img
              src={img}
              alt="Styles"
              style={{ width: "100%", height: "10rem", objectFit: "cover" }}
            />
          </div>
        ))}
      </div>
      <div>
        {catalogue.videoUrls.length > 0 ? (
          <>
            <MimaText
              mb={0.5}
              width={38}
              variant="small"
              color="var(--color-primary)"
            >
              Video(s)
            </MimaText>
            {catalogue.videoUrls.map((video, i) => (
              <div key={i}>
                {video?.includes("youtube.com") ||
                  (video?.includes("youtu.be") && (
                    <iframe
                      width="300"
                      height="169"
                      src={`https://www.youtube.com/embed/${extractVideoInfo(video).embedId}`}
                      title="YouTube Video"
                      allow="accelerometer;"
                      // allowFullScreen
                    />
                  ))}
                {video?.includes("vimeo.com") && (
                  <iframe
                    src={`https://player.vimeo.com/video/${extractVideoInfo(video).embedId}`}
                    width="300"
                    height="169"
                    allow="autoplay; fullscreen"
                    // allowFullScreen
                  ></iframe>
                )}
              </div>
            ))}
          </>
        ) : (
          ""
        )}
      </div>
    </Modal>
  );
};

export default SingleCatalogueModal;
